import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { Box, Typography, Tabs, Tab, useTheme, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, Stack, Divider } from '@mui/material';
import apiClient from '../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import DynamicTable from '../../components/Table/DataTable';
import { IconActivate, IconDeactivate, IconEye, IconReject } from '../../components/icons/icons';
import TablePaginationActions from '../../components/Table/tablePagination';
import { useLocation } from 'react-router-dom';
import LoadingScreen from '../../components/LoadingScreen';
import { getPendingVendors, updateVendorApproval } from '../../services/woocommerce';
export const statusColumn = (row: any, activeTab?: string) => {
    console.log(row)
    let statusText = "";
    let bgColor = "";
    let textColor = "";

    if (activeTab === "vendors") {
        switch (row.status) {
            case "approve":
                statusText = "Approved";
                bgColor = "#d1fae5";
                textColor = "#065f46";
                break;
            case "reject":
                statusText = "Rejected";
                bgColor = "#fee2e2";
                textColor = "#991b1b";
                break;
            default:
                statusText = "Pending";
                bgColor = "#fef3c7";
                textColor = "#92400e";
                break;
        }
    } if (activeTab === "vet_charge_codes") {
        switch (row.is_active) {
            case 1:
                statusText = "Approved";
                bgColor = "#d1fae5";
                textColor = "#065f46";
                break;
            case 2:
                statusText = "Rejected";
                bgColor = "#fee2e2";
                textColor = "#991b1b";
                break;
            default:
                statusText = "Pending";
                bgColor = "#fef3c7";
                textColor = "#92400e";
                break;
        }
    } else {
        switch (row.user?.is_active) {
            case 1:
                statusText = "Approved";
                bgColor = "#d1fae5";
                textColor = "#065f46";
                break;
            case 2:
                statusText = "Rejected";
                bgColor = "#fee2e2";
                textColor = "#991b1b";
                break;
            default:
                statusText = "Pending";
                bgColor = "#fef3c7";
                textColor = "#92400e";
                break;
        }
    }

    return (
        <span
            style={{
                backgroundColor: bgColor,
                color: textColor,
                padding: "4px 8px",
                borderRadius: "6px",
                fontWeight: "bold",
            }}
        >
            {statusText}
        </span>
    );
};
const ApprovalPage = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab =
        (queryParams.get("tab") as
            | "veterinarians"
            | "service_providers"
            | "vendors"
            | "vet_charge_codes"
            | "sp_charge_codes") || "veterinarians";

    const [approvals, setApprovals] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [activeTab, setActiveTab] = useState<
        | "veterinarians"
        | "service_providers"
        | "vendors"
        | "vet_charge_codes"
        | "sp_charge_codes"
    >(initialTab);

    const [openReasonModal, setOpenReasonModal] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState<any>(null);
    const [actionType, setActionType] = useState<"Approve" | "Reject" | null>(null);
    const [reason, setReason] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState<"all" | "pending" | "approved" | "rejected">("pending");

    const fetchApprovals = async (
        statusFilter: "all" | "pending" | "approved" | "rejected" = "all",
        searchKey: string = ""
    ) => {
        setLoading(true);
        setError(null);

        try {
            const params: any = {
                limit: rowsPerPage,
                page: page + 1,
                order_by: "id",
                dir: 2,
                searchkey: searchKey?.trim() || "",
            };

            let rawData: any;
            let normalized: any[] = [];

            if (activeTab === "veterinarians") {
                const response = await apiClient(
                    `/v1/resource/providers?${new URLSearchParams(params).toString()}`
                ) as any;
                rawData = response.data;
                normalized = rawData.providers.map((p: any) => ({
                    ...p,
                    type: "Veterinarian",
                }));
                setTotalCount(rawData.pagination?.total || normalized.length);
            } else if (activeTab === "service_providers") {
                const response = await apiClient(
                    `/v1/resource/service_providers?${new URLSearchParams(
                        params
                    ).toString()}`
                ) as any;
                rawData = response.data;
                normalized = rawData.service_providers.map((p: any) => ({
                    ...p,
                    type: "Service Provider",
                }));
                setTotalCount(rawData.pagination?.total || normalized.length);
            } else if (activeTab === "vendors") {
                const response = await getPendingVendors();
                rawData = response.data.vendors || [];
                normalized = rawData.map((v: any) => ({
                    ...v,
                    type: "Vendor",
                }));
                setTotalCount(response.data.count || normalized.length);
            } else if (activeTab === "vet_charge_codes") {
                // Fetch Veterinarian Charge Codes
                const response = await apiClient(`/v1/resource/ChargeCode`) as any;
                normalized = response.data?.charge_codes || [];
                setTotalCount(normalized.length);
            } else if (activeTab === "sp_charge_codes") {
                // Fetch Service Provider Charge Codes
                const response = await apiClient(`/v1/resource/ServiceChargeCode`) as any;
                normalized = response.data?.service_charge_codes || [];
                setTotalCount(normalized.length);
            }

            setApprovals(normalized);
        } catch (err: any) {
            setError(err.message || "Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateStr: string) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return "-";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    };
    const getRequestedDate = (row: any) => {
        if (activeTab === "vendors") {
            return row.registered;
        }
        return row.created_at || row.user?.created_at;
    };

    const getApprovalDate = (row: any) => {
        let dateStr = "";
        if (activeTab === "vendors") {
            if (row.status !== "pending") {
                dateStr = row.updated_at;
            }
        } else {
            if (row.user?.is_active !== 0) {
                dateStr = row.activated_at || row.user?.activated_at;
            }
        }
        return dateStr;
    };

    useEffect(() => {
        fetchApprovals();
    }, [activeTab, page, rowsPerPage]);

    const handleTabChange = (
        _event: React.SyntheticEvent,
        newValue:
            | "veterinarians"
            | "service_providers"
            | "vendors"
            | "vet_charge_codes"
            | "sp_charge_codes"
    ) => {
        setActiveTab(newValue);
        setPage(0);
        navigate(
            {
                pathname: location.pathname,
                search: `?tab=${newValue}`,
            },
            { replace: true }
        );
    };

    const handlePageChange = (newPage: number) => setPage(newPage);

    const handleRowsPerPageChange = (n: number) => {
        setRowsPerPage(n);
        setPage(0);
    };

    approvals.forEach((approval, index) => {
        console.log(`approval #${index} is_active:`, approval.user?.is_active);
    });

    const filteredApprovals = approvals.filter((item) => {
        if (activeTab === "vendors") {
            if (statusFilter === "all") return true;
            return statusFilter === "pending"
                ? item.status === "pending"
                : item.status === statusFilter;
        } else {
            if (statusFilter === "all") return true;

            const statusValue = item.user?.is_active ?? item?.is_active;

            if (statusFilter === "pending") return statusValue === 0;
            if (statusFilter === "approved") return statusValue === 1;
            if (statusFilter === "rejected") return statusValue === 2;

            return true;
        }
    });


    const baseSerialColumn = {
        key: "serial",
        label: "S.No",
        align: "left",
        render: (_row: any, index: number) => page * rowsPerPage + index + 1,
    };



    // ✅ Columns by tab type
    const veterinarianColumns = [
        baseSerialColumn,
        {
            key: "name",
            label: "Veterinarian Name",
            align: "left",
            render: (row: any) => `${row?.user?.first_name || ""} ${row?.user?.last_name || ""}`,
        },
        {
            key: "email",
            label: "Email",
            align: "left",
            render: (row: any) => row?.user?.email || "-",
        },
        {
            key: "dates",
            label: "Dates",
            align: "left",
            render: (row: any) => {
                const requested = formatDate(getRequestedDate(row)) || "-";
                const approval = formatDate(getApprovalDate(row)) || "-";

                return (
                    <div>
                        <div><strong>Requested Date:</strong> {requested}</div>
                        <div><strong>Approval Date:</strong> {approval}</div>
                    </div>
                );
            },
        },

        {
            key: "status",
            label: "Status",
            align: "left",
            render: (row: any) => statusColumn(row, "veterinarians"),
        },
    ];

    const serviceProviderColumns = [
        baseSerialColumn,
        {
            key: "name",
            label: "Service Provider Name",
            align: "left",
            render: (row: any) => `${row?.user?.first_name || ""} ${row?.user?.last_name || ""}`,
        },
        {
            key: "email",
            label: "Email",
            align: "left",
            render: (row: any) => row?.user?.email || "-",
        },
        {
            key: "dates",
            label: "Dates",
            align: "left",
            render: (row: any) => {
                const requested = formatDate(getRequestedDate(row)) || "-";
                const approval = formatDate(getApprovalDate(row)) || "-";

                return (
                    <div>
                        <div><strong>Requested Date:</strong> {requested}</div>
                        <div><strong>Approval Date:</strong> {approval}</div>
                    </div>
                );
            },
        },

        {
            key: "status",
            label: "Status",
            align: "left",
            render: (row: any) => statusColumn(row, "service_providers"),
        },
    ];

    const vendorColumns = [
        baseSerialColumn,
        {
            key: "name",
            label: "Vendor Name",
            align: "left",
            render: (row: any) => row?.store_name || row?.name || "-",
        },
        {
            key: "email",
            label: "Email",
            align: "left",
            render: (row: any) => row?.email || "-",
        },
        {
            key: "registered",
            label: "Registered Date",
            align: "left",
            render: (row: any) => {
                if (!row?.registered) return "-";
                const date = new Date(row.registered);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                let hours = date.getHours();
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const ampm = hours >= 12 ? "PM" : "AM";
                hours = hours % 12 || 12;
                return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
            },
        },
        {
            key: "dates",
            label: "Dates",
            align: "left",
            render: (row: any) => {
                const requested = formatDate(getRequestedDate(row)) || "-";
                const approval = formatDate(getApprovalDate(row)) || "-";

                return (
                    <div>
                        <div><strong>Requested Date:</strong> {requested}</div>
                        <div><strong>Approval Date:</strong> {approval}</div>
                    </div>
                );
            },
        },

        {
            key: "status",
            label: "Status",
            align: "left",
            render: (row: any) => statusColumn(row, "vendors"),
        },
    ];

    const vetChargeCodeColumns = [
        baseSerialColumn,
        {
            key: "vrt_charge_code",
            label: "Charge Code",
            align: "left",
            render: (row: any) => row?.charge_code || "-",
        },
        {
            key: "description",
            label: "Service Name",
            align: "left",
            render: (row: any) => row?.service_name || "-",
        },
        {
            key: "service_type",
            label: "Service Type",
            align: "left",
            render: (row: any) => row?.service_type || "-",
        },
        {
            key: "tax",
            label: "Tax Details",
            align: "left",
            render: (row: any) => {
                const baseAmount = parseFloat(row?.amount || "0");
                let taxDetails: { name: string; value: number; type: string }[] = [];
                let totalTax = 0;

                try {
                    let taxCodes: any[] = [];

                    if (typeof row.tax_codes === "string") {
                        taxCodes = JSON.parse(row.tax_codes);
                    } else if (Array.isArray(row.tax_codes)) {
                        taxCodes = row.tax_codes;
                    }

                    // Normalize
                    taxCodes = taxCodes.map((t: any) =>
                        typeof t === "string" ? JSON.parse(t) : t
                    );

                    taxCodes.forEach((tax: any) => {
                        const rate = parseFloat(tax.rate || "0");
                        let value = 0;
                        if (tax.type === "percentage") value = (baseAmount * rate) / 100;
                        else if (tax.type === "adhoc") value = rate;
                        totalTax += value;
                        taxDetails.push({
                            name: tax.name || tax.code,
                            value,
                            type: tax.type,
                        });
                    });
                } catch (err) {
                    console.error("Error parsing tax_codes:", err);
                }

                const totalAmount = totalTax;
                const hasTax = taxDetails.length > 0;

                return (
                    <Box
                        sx={{
                            backgroundColor: "#f9fafb",
                            borderRadius: 2,
                            p: 1.5,
                            border: "1px solid #e5e7eb",
                            width: "fit-content",
                            minWidth: 180,
                        }}
                    >
                        {hasTax ? (
                            <Stack spacing={0.5}>
                                <Typography
                                    variant="body2"
                                    fontWeight={600}
                                    color="text.primary"
                                >
                                    Base: ₹{baseAmount.toFixed(2)}
                                </Typography>

                                <Divider sx={{ my: 0.5 }} />

                                {taxDetails.map((tax, index) => (
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        key={index}
                                    >
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            {tax.name}{" "}
                                            <Typography
                                                component="span"
                                                sx={{ fontSize: 12, color: "#9ca3af" }}
                                            >
                                                ({tax.type})
                                            </Typography>
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            fontWeight={500}
                                            color="text.primary"
                                        >
                                            ₹{tax.value.toFixed(2)}
                                        </Typography>
                                    </Stack>
                                ))}

                                <Divider sx={{ my: 0.5 }} />

                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ mt: 0.5 }}
                                >
                                    <Typography
                                        variant="body2"
                                        fontWeight={600}
                                        color="text.primary"
                                    >
                                        Total Tax
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        fontWeight={600}
                                        color="success.main"
                                    >
                                        ₹{totalAmount.toFixed(2)}
                                    </Typography>
                                </Stack>

                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ mt: 0.5 }}
                                >
                                    <Typography
                                        variant="body2"
                                        fontWeight={600}
                                        color="text.primary"
                                    >
                                        Total Amount
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        fontWeight={600}
                                        color="primary.main"
                                    >
                                        ₹{parseFloat(row?.total_amount || "0").toFixed(2)}
                                    </Typography>
                                </Stack>
                            </Stack>
                        ) : (
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                fontStyle="italic"
                            >
                                No Tax Applied
                            </Typography>
                        )}
                    </Box>
                );
            },
        },

        {
            key: "dates",
            label: "Dates",
            align: "left",
            render: (row: any) => {
                const requested = formatDate(getRequestedDate(row)) || "-";
                const approval = formatDate(getApprovalDate(row)) || "-";

                return (
                    <div>
                        <div><strong>Requested Date:</strong> {requested}</div>
                        <div><strong>Approval Date:</strong> {approval}</div>
                    </div>
                );
            },
        },
        {
            key: "status",
            label: "Status",
            align: "left",
            render: (row: any) => statusColumn(row, "vet_charge_codes"),
        },
    ];
    const serviceChargeCodeColumns = [
        baseSerialColumn,
        {
            key: "service_details",
            label: "Service Details",
            align: "left",
            render: (row: any) => {
                const chargeCode = row?.charge_code || "-";
                const serviceName = row?.service_name || "-";
                const serviceType = row?.service_type
                    ? row.service_type
                        .replace(/[-_]/g, ' ')
                        .replace(/\b\w/g, (char: string) => char.toUpperCase())
                    : "-";

                const duration = row?.duration
                    ? `${Number(row.duration) * 60} Mins`
                    : "-";

                return (
                    <div>
                        <div><strong>Charge Code:</strong> {chargeCode}</div>
                        <div><strong>Service Name:</strong> {serviceName}</div>
                        <div><strong>Service Type:</strong> {serviceType}</div>
                        <div><strong>Duration:</strong> {duration}</div>
                    </div>
                );
            },
        },
        {
            key: "tax",
            label: "Tax Details",
            align: "left",
            render: (row: any) => {
                const baseAmount = parseFloat(row?.amount || "0");
                let taxDetails: { name: string; value: number; type: string }[] = [];
                let totalTax = 0;

                try {
                    // Get tax codes either from row.tax_codes or from additional_info.tax_codes
                    let taxCodes: any[] = [];

                    if (row?.additional_info?.tax_codes) {
                        taxCodes = row.additional_info.tax_codes;
                    } else if (typeof row.tax_codes === "string") {
                        taxCodes = JSON.parse(row.tax_codes);
                    } else if (Array.isArray(row.tax_codes)) {
                        taxCodes = row.tax_codes;
                    }

                    // Normalize strings to objects
                    taxCodes = taxCodes.map((t: any) => (typeof t === "string" ? JSON.parse(t) : t));

                    // Calculate tax values
                    taxCodes.forEach((tax: any) => {
                        const rate = parseFloat(tax.rate || "0");
                        let value = 0;
                        if (tax.type === "percentage") value = (baseAmount * rate) / 100;
                        else if (tax.type === "adhoc") value = rate;

                        totalTax += value;
                        taxDetails.push({
                            name: tax.name || tax.code,
                            value,
                            type: tax.type,
                        });
                    });
                } catch (err) {
                    console.error("Error parsing tax_codes:", err);
                }

                const hasTax = taxDetails.length > 0;

                return (
                    <Box
                        sx={{
                            backgroundColor: "#f9fafb",
                            borderRadius: 2,
                            p: 1.5,
                            border: "1px solid #e5e7eb",
                            width: "fit-content",
                            minWidth: 180,
                        }}
                    >
                        {hasTax ? (
                            <Stack spacing={0.5}>
                                <Typography variant="body2" fontWeight={600} color="text.primary">
                                    Base: ₹{baseAmount.toFixed(2)}
                                </Typography>

                                <Divider sx={{ my: 0.5 }} />

                                {taxDetails.map((tax, index) => (
                                    <Stack direction="row" justifyContent="space-between" key={index}>
                                        <Typography variant="body2" color="text.secondary">
                                            {tax.name}{" "}
                                            <Typography component="span" sx={{ fontSize: 12, color: "#9ca3af" }}>
                                                ({tax.type})
                                            </Typography>
                                        </Typography>
                                        <Typography variant="body2" fontWeight={500} color="text.primary">
                                            ₹{tax.value.toFixed(2)}
                                        </Typography>
                                    </Stack>
                                ))}

                                <Divider sx={{ my: 0.5 }} />

                                <Stack direction="row" justifyContent="space-between" sx={{ mt: 0.5 }}>
                                    <Typography variant="body2" fontWeight={600} color="text.primary">
                                        Total Tax
                                    </Typography>
                                    <Typography variant="body2" fontWeight={600} color="success.main">
                                        ₹{totalTax.toFixed(2)}
                                    </Typography>
                                </Stack>

                                <Stack direction="row" justifyContent="space-between" sx={{ mt: 0.5 }}>
                                    <Typography variant="body2" fontWeight={600} color="text.primary">
                                        Total Amount
                                    </Typography>
                                    <Typography variant="body2" fontWeight={600} color="primary.main">
                                        ₹{parseFloat(row?.total_amount || "0").toFixed(2)}
                                    </Typography>
                                </Stack>
                            </Stack>
                        ) : (
                            <Typography variant="body2" color="text.secondary" fontStyle="italic">
                                No Tax Applied
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        {
            key: "dates",
            label: "Dates",
            align: "left",
            render: (row: any) => {
                const requested = formatDate(getRequestedDate(row)) || "-";
                const approval = formatDate(getApprovalDate(row)) || "-";

                return (
                    <div>
                        <div><strong>Requested Date:</strong> {requested}</div>
                        <div><strong>Approval Date:</strong> {approval}</div>
                    </div>
                );
            },
        },
        {
            key: "status",
            label: "Status",
            align: "left",
            render: (row: any) => statusColumn(row, "vet_charge_codes"),
        },
    ];
    const columns =
        activeTab === "veterinarians"
            ? veterinarianColumns
            : activeTab === "service_providers"
                ? serviceProviderColumns
                : activeTab === "vendors"
                    ? vendorColumns
                    : activeTab === "vet_charge_codes"
                        ? vetChargeCodeColumns
                        : activeTab === "sp_charge_codes" ? serviceChargeCodeColumns
                            : [];



    const handleShowDetails = (item: any) => {
        let path = "";
        if (activeTab === "veterinarians") {
            path = `/veterinarians/details/${item.id}`;
        } else if (activeTab === "service_providers") {
            path = `/service-providers/details/${item.id}`;
        } else if (activeTab === "vendors") {
            path = `/vendor/details/${item.id}`;
        } else if (activeTab === "vet_charge_codes") {
            path = `/vet_charge_codes/details/${item.id}`;
        }
        else if (activeTab === "sp_charge_codes") {
            path = `/service_charge_codes/details/${item.id}`;
        }

        navigate(path, {
            state: {
                item,
                type: 'approve',
                fromTab: activeTab,
            },
        });
    };


    const buildPayload = (row: any, isActive: number, role: 'veterinarian' | 'service_provider') => ({
        id: row?.user_id,
        license_no: row?.license_no,
        role,
        first_name: row?.user?.first_name,
        mobile: row?.user?.mobile,
        username: row?.user?.username,
        timezone_id: row?.user?.timezone?.id,
        is_2fa: row?.user?.is_2fa,
        is_active: isActive,
    });

    const handleUserAction = async (
        row: any,
        actionLabel: string,
        isActive: number,
        errorMessage: string
    ) => {
        console.log('Selected Row:', row);

        // Determine display name for confirmation
        const actionName =
            activeTab === 'veterinarians'
                ? `${row?.user?.first_name ?? ''} ${row?.user?.last_name ?? ''}`.trim()
                : activeTab === 'vet_charge_codes' || activeTab === 'sp_charge_codes'
                    ? `${row?.charge_code} - ${row?.service_name}`
                    : row?.name ?? '';

        // Confirm user action
        const confirmed = window.confirm(
            `Are you sure you want to ${actionLabel.toLowerCase()} ${actionName}?`
        );
        if (!confirmed) return;

        try {
            let payload: any = {};
            let endpoint = '';

            if (activeTab === 'vet_charge_codes') {
                payload = { is_active: isActive };
                endpoint = `/v1/resource/ChargeCode/${row.id}`;
            }
            else if (activeTab === 'sp_charge_codes') {
                payload = { is_active: isActive };
                endpoint = `/v1/resource/ServiceChargeCode/${row.id}`;
            }
            else if (activeTab === 'veterinarians' || activeTab === 'service_providers') {
                const role: 'veterinarian' | 'service_provider' =
                    activeTab === 'veterinarians' ? 'veterinarian' : 'service_provider';

                payload = buildPayload(row, isActive, role);
                endpoint = `v1/resource/users/${row.user_id}`;
            }
            else {
                console.warn('Invalid activeTab:', activeTab);
                return;
            }

            // ✅ Log payload and endpoint before API call
            console.log('API Payload:', payload);
            console.log('API Endpoint:', endpoint);

            await apiClient(endpoint, {
                method: 'PATCH',
                body: payload,
            });

            await fetchApprovals();
            console.log(`✅ ${actionLabel} action completed successfully for:`, actionName);

        } catch (error: any) {
            console.error('❌ Error in handleUserAction:', error);
            alert(`${errorMessage}: ${error.message || 'Unknown error'}`);
        }
    };


    const handleVendorAction = (row: any, action: "Approve" | "Reject") => {
        setSelectedVendor(row);
        setActionType(action);
        setReason("");
        setOpenReasonModal(true);
    };

    const handleConfirmAction = async () => {
        // Only require reason if action is "Reject"
        if (actionType === "Reject" && !reason.trim()) {
            alert("Please enter a reason before submitting.");
            return;
        }

        const status = actionType === "Approve" ? "approve" : "reject";

        try {
            await updateVendorApproval(selectedVendor.id, status, reason);
            await fetchApprovals();
            setOpenReasonModal(false);
        } catch (error: any) {
            alert(`Failed to ${status} vendor: ${error.message || "Unknown error"}`);
        }
    };
    const reasonLabel = actionType
        ? `Reason for ${actionType === "Approve" ? "Approval" : "Rejection"}`
        : "Reason";

    const reasonPlaceholder = actionType
        ? `Enter reason for ${actionType === "Approve" ? "approval" : "rejection"}...`
        : "Enter reason...";
    const actions = activeTab === "vendors"
        ? [
            {
                label: "View",
                color: "#2196f3",
                icon: <IconEye size={20} />,
                onClick: (row: any) => handleShowDetails(row),
            },
            {
                label: "Approve",
                color: "#2e7d32",
                icon: <IconActivate size={20} />,
                onClick: (row: any) => handleVendorAction(row, "Approve"),
            },
            {
                label: "Reject",
                color: "#d32f2f",
                icon: <IconReject size={20} />,
                onClick: (row: any) => handleVendorAction(row, "Reject"),
            },
        ]
        : [
            {
                label: "View",
                color: "#2196f3",
                icon: <IconEye size={20} />,
                onClick: (row: any) => handleShowDetails(row),
            },
            {
                label: "Approve",
                color: "#2e7d32",
                icon: <IconActivate size={20} />,
                onClick: (row: any) => handleUserAction(row, "Approve", 1, "Failed to approve the user"),
            },
            {
                label: "Reject",
                color: "#d32f2f",
                icon: <IconReject size={20} />,
                onClick: (row: any) => handleUserAction(row, "Reject", 2, "Failed to reject the user"),
            },
        ];

    if (loading) return <LoadingScreen message="Loading Approvals..." />;

    if (error) {
        return (
            <Layout>
                <Typography color="error">Error: {error}</Typography>
            </Layout>
        );
    }

    return (
        <Layout>
            <Box p={4}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    aria-label="Approval Tabs"
                    sx={{ mb: 3 }}
                >
                    <Tab label="Veterinarians" value="veterinarians" />
                    <Tab label="Service Providers" value="service_providers" />
                    <Tab label="Vendors" value="vendors" />
                    <Tab label="Veterinarian Charge Codes" value="vet_charge_codes" />
                    <Tab label="Service Provider Charge Codes" value="sp_charge_codes" />
                </Tabs>
                {(activeTab !== 'vendors') && (
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={3}
                        p={2}
                        sx={{
                            backgroundColor: "#f9fafb",
                            borderRadius: 3,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        {/* Search + Buttons combined */}
                        <Box display="flex" alignItems="center">
                            <TextField
                                label="Search"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                size="small"
                                sx={{
                                    width: '250px',
                                    backgroundColor: "#fff",
                                    borderRadius: 2,
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 2,
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    },
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setPage(0);
                                        setSearchTerm(searchInput);
                                        fetchApprovals(statusFilter);
                                    }
                                }}
                            />

                            <Button
                                variant="contained"
                                sx={{
                                    ml: 1,
                                    height: '36px',
                                    borderRadius: 2,
                                    backgroundColor: "#4f46e5",
                                    "&:hover": { backgroundColor: "#4338ca", transform: "translateY(-1px)" },
                                    textTransform: "none",
                                }}
                                onClick={() => {
                                    setPage(0);
                                    fetchApprovals(statusFilter, searchInput.trim());
                                }}
                            >
                                Search
                            </Button>

                            <Button
                                variant="outlined"
                                sx={{
                                    ml: 1,
                                    height: '36px',
                                    borderRadius: 2,
                                    borderColor: "#9ca3af",
                                    color: "#374151",
                                    "&:hover": { backgroundColor: "#f3f4f6", borderColor: "#6b7280" },
                                    textTransform: "none",
                                }}
                                onClick={() => {
                                    setSearchInput('');
                                    setPage(0);
                                    fetchApprovals(statusFilter, '');
                                }}
                            >
                                Clear
                            </Button>

                        </Box>

                        {/* Status filter */}
                        <FormControl
                            size="small"
                            sx={{
                                minWidth: 180,
                                ml: 2,
                                "& .MuiInputLabel-root": { fontWeight: 500 },
                                "& .MuiOutlinedInput-root": { borderRadius: 2, backgroundColor: "#fff" },
                            }}
                        >
                            <InputLabel>Status</InputLabel>
                            <Select
                                value={statusFilter}
                                label="Status"
                                onChange={(e) => {
                                    const value = e.target.value as 'all' | 'pending' | 'approved' | 'rejected';
                                    setStatusFilter(value);
                                    setPage(0);
                                    fetchApprovals(value); // fetch on status change
                                }}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="pending">Pending</MenuItem>
                                <MenuItem value="approved">Approved</MenuItem>
                                <MenuItem value="rejected">Rejected</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                )}

                <DynamicTable
                    columns={columns}
                    data={filteredApprovals}
                    loading={loading}
                    actions={actions}
                    page={page}
                    error={error}
                    rowsPerPage={rowsPerPage}
                    totalCount={totalCount}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                    ActionsComponent={TablePaginationActions}
                />
            </Box>
            <Dialog
                open={openReasonModal}
                onClose={() => setOpenReasonModal(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 8px 30px rgba(0,0,0,0.15)",
                        overflow: "hidden",
                    },
                }}
            >
                {/* HEADER */}
                <DialogTitle
                    sx={{
                        backgroundColor: actionType === "Approve" ? "#2e7d32" : "#d32f2f",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "1.2rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 3,
                        py: 2,
                    }}
                >
                    <span>
                        {actionType} Vendor
                        <Typography
                            variant="body2"
                            component="span"
                            sx={{ ml: 1, fontWeight: 400, opacity: 0.9 }}
                        >
                            - {selectedVendor?.store_name || selectedVendor?.name}
                        </Typography>
                    </span>
                </DialogTitle>

                {/* CONTENT */}
                <DialogContent
                    sx={{
                        px: 3,
                        py: 4,
                        backgroundColor: "#fafafa",
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{
                            mb: 1.5,
                            fontWeight: 600,
                            color: "#111827",
                        }}
                    >
                        {reasonLabel}
                    </Typography>

                    <TextField
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        fullWidth
                        multiline
                        rows={4}
                        variant="outlined"
                        placeholder={reasonPlaceholder}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                backgroundColor: "#fff",
                                transition: "all 0.2s ease",
                                "& fieldset": {
                                    borderColor: "#d1d5db",
                                },
                                "&:hover fieldset": {
                                    borderColor: actionType === "Approve" ? "#2e7d32" : "#d32f2f",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: actionType === "Approve" ? "#2e7d32" : "#d32f2f",
                                    boxShadow:
                                        actionType === "Approve"
                                            ? "0 0 0 3px rgba(46,125,50,0.15)"
                                            : "0 0 0 3px rgba(211,47,47,0.15)",
                                },
                            },
                        }}
                    />

                    <Typography
                        variant="caption"
                        sx={{
                            mt: 1,
                            color: "#6b7280",
                            fontStyle: "italic",
                            display: "block",
                        }}
                    >
                        * This reason will be recorded for reference.
                    </Typography>
                </DialogContent>

                {/* FOOTER */}
                <DialogActions
                    sx={{
                        justifyContent: "space-between",
                        px: 3,
                        py: 2,
                        backgroundColor: "#f4f5f7",
                        borderTop: "1px solid #e5e7eb",
                    }}
                >
                    <Button
                        onClick={() => setOpenReasonModal(false)}
                        variant="outlined"
                        color="inherit"
                        sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            py: 1,
                            fontWeight: 500,
                            "&:hover": { backgroundColor: "#e5e7eb" },
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleConfirmAction}
                        variant="contained"
                        sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            py: 1,
                            fontWeight: 500,
                            backgroundColor: actionType === "Approve" ? "#2e7d32" : "#d32f2f",
                            "&:hover": {
                                backgroundColor: actionType === "Approve" ? "#256629" : "#b71c1c",
                                transform: "translateY(-1px)",
                                transition: "all 0.2s ease-in-out",
                            },
                        }}
                    >
                        {actionType}
                    </Button>
                </DialogActions>
            </Dialog>
        </Layout>
    );
};

export default ApprovalPage;
